import { getDoctorDepartment } from "api/hospital";
import { useEffect, useState } from "react";
import { onClickhref } from "utils";
import styles from "../index.less";
import Blank from "../components/blank";

const DepartmentList = ({ pageId, showAll = false } : any) => {
  const moreUrl = `/hospital/${pageId}/keshilist`;
  const [data, setDepartmentList] = useState<any>([]);
  useEffect(() => {
    getDepartment();
  }, []);
  // 获取科室列表
  const getDepartment = () => {
    getDoctorDepartment({ hospitalId: pageId }).then((res: any) => {
      setDepartmentList(res.department.slice(1));
    })
  }
  // 掉楼逻辑
  if (!data?.length) {
    return null;
  }
  return (
    <Blank className={styles.departmentList} title="医院科室" moreUrl={!showAll && moreUrl}>
      <div className={styles.content}>
        {
          data?.length > 0 && data?.map((firstDepartment: any, index: number) => (
            <>
              <div className={styles.departItem} key={firstDepartment.id} style={{ display: showAll || index <= 2 ? '' : 'none' }}>
                <div className={styles.firstDepart} title={firstDepartment?.departName}>
                  <p title={firstDepartment?.departName}>{firstDepartment?.departName}</p>
                </div>
                <div className={styles.right}>
                  {firstDepartment?.subDepartList?.length > 0
                  && firstDepartment?.subDepartList?.slice(1)?.map(
                    (superDepart: any, superIndex: number) => (
                      <div
                        className={styles.squre}
                        key={superDepart?.id}
                        onClick={() => onClickhref(`/hospital/department/${pageId}-${superDepart.id}`)}
                        style={{ display: showAll || superIndex <= 6 ? '' : 'none' }}>
                        <span data-a-href={`/hospital/department/${pageId}-${superDepart?.id}`}>{superDepart?.departName}</span>
                      </div>
                      )
                    )
                  }
                  {!showAll && <div data-a-nofollow="true" className={styles.squreAll} onClick={() => {
                    onClickhref(moreUrl);
                  }}>
                    <span>查看全部</span>
                  </div>}
                </div>
              </div>

              {(showAll || index + 1 <= 2)  && <div className={styles.divider}><div className={showAll ? styles.noHalfDivider : styles.all} /></div>}
            </>
          ))
        }
      </div>
    </Blank>
  );
}
export default DepartmentList;